import React from 'react';
import '../css/LoadingSpinner.css'; // Import the CSS for the spinner

const LoadingSpinner = ({isBlur}) => (
    <div className={isBlur ? "loading-overlay" : "loading-overlay-no-blur"}>
        <div className="loading-spinner"></div>
    </div>
);

export default LoadingSpinner;
